import React from 'react'
import './bussiness_form.scss'
import { Row, Col, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
const BussinessForm = () => {
    const Selectoptions = [
        { value: 'Constructions', label: 'Constructions' },
        { value: 'DealerShip', label: 'DealerShip' },
        { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
        { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
        { value: 'Service industries', label: 'Service industries' },
        { value: 'Trucking', label: 'Trucking' },
    ];
    return (
        <div className='bussiness_form'>
            <Row>
                <Col sm={12} md={12} lg={8} xl={8}>
                    <div className='talk-form-main'>
                        <div className='top-heading'>
                            <h3>Tell us about your business</h3>
                            <p>Experience the Sentry difference like others in your industry already have.
                                Complete this simple form and a Sentry representative will contact you if we’re a good match and we can help fulfill your workers’ compensation requirements.</p>
                            <h4 className='sub_heading'>Business info</h4>
                        </div>
                        <Form>
                            <Row>
                                <Col sm={12} >
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>Industry*</Form.Label>
                                        <div className=''>
                                            <Select
                                                options={Selectoptions}
                                                placeholder="Select an industry"
                                                classNamePrefix="react-select"
                                            />
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Company name*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Address*</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>City*</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} md={3} lg={3} xl={3}>
                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                        <Form.Label>State* </Form.Label>
                                        <div className=''>
                                            <Select
                                                options={Selectoptions}
                                                classNamePrefix="react-select"
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} md={3} lg={3} xl={3}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>ZIP* </Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} md={3} lg={3} xl={3}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Year established*</Form.Label>
                                        <Form.Control type="date" />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Number of employees</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Annual payroll</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Annual sales </Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Are you currently working with an independent agent or broker?                                        </Form.Label>
                                        <Form.Check
                                            type='radio'
                                            id='default-radio'
                                            label='Yes'
                                            name='working'
                                        />
                                        <Form.Check
                                            type='radio'
                                            id='default-radio'
                                            label='No'
                                            name='working'

                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Agency/brokerage name</Form.Label>
                                        <Form.Control type="text" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className='top-heading mt-5'>
                                <h4 className='sub_heading'>Contact info </h4>
                            </div>
                            <Row>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>First name </Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Last name </Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Phone*</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} md={6} lg={6} xl={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Email*</Form.Label>
                                        <Form.Control />
                                    </Form.Group>
                                </Col>
                                <Col sm={12} className='mb-3'>
                                    <Form.Group className="mb-0">
                                        <Form.Label>Tell us more about your workers' compensation requirements.</Form.Label>
                                        <Form.Control as="textarea" rows={7} className='mb-0'/>
                                    </Form.Group>
                                    <span className='small_text right'>0/2000</span>
                                    <span className='small_text'>Please don’t provide sensitive personal information (e.g., your Social Security number, date of birth, or driver’s license number). If we need additional information, we’ll contact you directly. Thank you.
                                    </span>
                                </Col>
                                <Col sm={12} md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Current policy expiration date</Form.Label>
                                        <Form.Control type='date'/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className='term-condition'>
                                <p>By pressing submit form, you agree that the information you are providing is your own and we may use the information you provide according to our <a href="https://www.sentry.com/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a> and <a href="https://www.sentry.com/terms-and-conditions" rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a>.</p>
                            </div>
                            <div className='bottom-btn'>
                                <Button className='submit-btn' type="submit">
                                    Submit form
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
                {/* <Col sm={12} md={4} lg={4} xl={4}>
                    <div className='media-img'>
                      <img src={images['GolfBallTees.avif']} alt="media" />
                   </div>
                </Col> */}
            </Row>
        </div>
    )
}

export default BussinessForm;